var map = {
	"./BCBG.png": 969,
	"./Estee.png": 54911,
	"./FIdelity.svg": 77715,
	"./Napster.png": 88216,
	"./Netcoins.png": 69656,
	"./PWC.png": 62575,
	"./WarnerRecords.png": 92216
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77722;